/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import useEnterpriseMegaMenuLinks, {
  useEnterpriseOrgScopedMenuLinks,
} from 'bundles/composable-page-header-enterprise/hooks/useEnterpriseMegaMenuLinks';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';

const styles = {
  exploreButtonHeaderSpacing: css`
    margin-left: var(--cds-spacing-100);
    margin-right: calc(var(--cds-spacing-50) * -1);
  `,
};

const ExploreMegaMenuGridItem = () => {
  const isOrgScopedHome = GrowthDiscoveryEpicClient.preview('orgScopedHome');
  const orgScopedLinks = useEnterpriseOrgScopedMenuLinks();
  const megaMenuLinks = useEnterpriseMegaMenuLinks();
  const links = isOrgScopedHome ? orgScopedLinks : megaMenuLinks;

  return (
    <MegaMenuLinksProvider links={links} isEnterprise>
      <div className="rc-ExploreMegaMenuGridItem" css={styles.exploreButtonHeaderSpacing}>
        <SimplifiedMegaMenuWrapper />
      </div>
    </MegaMenuLinksProvider>
  );
};

export default ExploreMegaMenuGridItem;
